import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../utils/axiosConfig';
import './Login.css';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await axiosInstance.post('/api/auth/forgot-password', {
        email: email.trim().toLowerCase(),
      });

      setMessage({
        type: response.data.success ? 'success' : 'error',
        text:
          response.data.message ||
          'If that email matches a saved recovery address, we sent a reset link. Check inbox and spam.',
      });
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.response?.data?.message || 'Could not send reset email. Please try again.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <button
            type="button"
            className="login-back-home"
            onClick={() => navigate('/login')}
          >
            ← Back to login
          </button>
          <img className="login-logo" src="/atozasmail-logo.png" alt="ATOZASMail" />
          <h2>Forgot password</h2>
          <p className="subtitle">
            Enter your recovery email (Gmail, Yahoo, etc.). We&apos;ll send the reset link there.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Recovery email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (message.text) setMessage({ type: '', text: '' });
              }}
              placeholder="you@gmail.com"
              className="form-input"
              required
              disabled={loading}
              autoFocus
            />
            <small className="form-hint">
              Use the external email saved on your account. You can also enter your
              @atozasmail.in address.
            </small>
          </div>

          {message.text && (
            <div className={`message ${message.type}`}>{message.text}</div>
          )}

          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? 'Please wait...' : 'Send reset link'}
          </button>
        </form>

        <div className="login-footer">
          <p>
            Remembered your password?{' '}
            <button
              type="button"
              onClick={() => navigate('/login')}
              className="toggle-button"
              disabled={loading}
            >
              Sign in
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
